import { GET_FUTURE_MESSAGES } from "../actions/types";

const initState = {
  future_messages: [],
  single_message: {},
  loading: false,
};

const futuremessageReducer = (state = initState, action) => {
  switch (action.type) {
    case GET_FUTURE_MESSAGES:
      return {
        ...state,
        future_messages: action.payload,
      };
    case "FUTURE_MESSAGE_LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    case "GET_SINGLE_MESSAGE":
      return {
        ...state,
        single_message: action.payload,
      };
    default:
      return state;
  }
};

export default futuremessageReducer;
